module.exports = __webpack_public_path__ + "static/media/md-arrow-round-down.900a59b8.svg";